export class UserUnauthorizedError extends Error {
  constructor() {
    super('errors.unauthorized');
  }
}